import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    meta: {
      icon: 'mdi:cog-outline',
      order: 110,
      title: '系统配置',
    },
    name: 'SystemConfig',
    path: '/system-config',
    children: [
      {
        name: 'PreRechargeConfig',
        path: '/pre-recharge-config',
        component: () =>
          import('#/views/system-config/pre-recharge-config/index.vue'),
        meta: {
          icon: 'mdi:wallet-outline',
          title: '预充配置',
          keepAlive: true,
        },
      },
      {
        name: 'OpenAccountRuleConfig',
        path: '/open-account-rule-config',
        component: () =>
          import('#/views/system-config/open-account-rule-config/index.vue'),
        meta: {
          icon: 'mdi:tune-variant',
          title: '开户费用配置',
          keepAlive: true,
        },
      },
      {
        name: 'SystemDict',
        path: '/system-dict',
        component: () => import('#/views/system-config/system-dict/index.vue'),
        meta: {
          icon: 'mdi:format-list-bulleted',
          pageKey: 'SystemDict',
          title: '系统字典',
          keepAlive: true,
        },
      },
      {
        name: 'PermissionAuditLog',
        path: '/permission-audit-log',
        component: () =>
          import('#/views/system-config/permission-audit-log/index.vue'),
        meta: {
          icon: 'mdi:shield-account-outline',
          title: '权限审计日志',
          keepAlive: true,
        },
      },
      {
        name: 'ClientMenuConfig',
        path: '/client-menu-config',
        component: () =>
          import('#/views/system-config/client-menu-config/index.vue'),
        meta: {
          icon: 'mdi:file-tree-outline',
          title: '客户端菜单',
          keepAlive: true,
        },
      },
      {
        name: 'NoticeConfig',
        path: '/notice-config',
        component: () =>
          import('#/views/system-config/notice-config/index.vue'),
        meta: {
          icon: 'mdi:message-text-outline',
          title: '通知配置',
          keepAlive: true,
        },
      },
      {
        name: 'ConsumptionDropAlertConfig',
        path: '/consumption-drop-alert-config',
        component: () =>
          import(
            '#/views/system-config/consumption-drop-alert-config/index.vue'
          ),
        meta: {
          icon: 'mdi:trending-down',
          pageKey: 'ConsumptionDropAlertConfig',
          title: '消耗下降提醒配置',
          keepAlive: true,
        },
      },
    ],
  },
]

export default routes
